import { jsx as g } from "react/jsx-runtime";
import { forwardRef as l } from "react";
import h from "styled-components";
const s = {
  "2xl": "var(--font-size-3xl)",
  xl: "var(--font-size-2xl)",
  lg: "var(--font-size-xl)",
  md: "var(--font-size-lg)",
  sm: "var(--font-size-md)",
  xs: "var(--font-size-sm)",
  "2xs": "var(--font-size-xs)"
}, d = {
  "2xl": "var(--font-family-brand)",
  xl: "var(--font-family-brand)",
  lg: "var(--font-family-brand)",
  md: "var(--font-family-base)",
  sm: "var(--font-family-base)",
  xs: "var(--font-family-base)",
  "2xs": "var(--font-family-base)"
}, m = {
  "2xl": "var(--text-heading-highlight-color)",
  xl: "var(--text-heading-highlight-color)",
  lg: "var(--text-heading-highlight-color)",
  md: "var(--text-heading-color)",
  sm: "var(--text-heading-color)",
  xs: "var(--text-heading-color)",
  "2xs": "var(--text-heading-color)"
}, v = {
  "2xl": "var(--font-weight-bold)",
  xl: "var(--font-weight-bold)",
  lg: "var(--font-weight-bold)",
  md: "var(--font-weight-medium)",
  sm: "var(--font-weight-medium)",
  xs: "var(--font-weight-medium)",
  "2xs": "var(--font-weight-medium)"
}, f = {
  "2xl": "var(--line-height-sm)",
  xl: "var(--line-height-sm)",
  lg: "var(--line-height-sm)",
  md: "var(--line-height-md)",
  sm: "var(--line-height-md)",
  xs: "var(--line-height-md)",
  "2xs": "var(--line-height-md)"
}, x = h.h1.withConfig({
  displayName: "Heading",
  componentId: "sc-1j2y83t-0"
})(["letter-spacing:var(--letter-spacing-negative);margin:0;", ""], ({
  size: a
}) => a && `
            font-size: ${s[a]};
            font-family: ${d[a]};
            color: ${m[a]};
            font-weight: ${v[a]};
            line-height: ${f[a]};
        `), t = {
  "2XS": "2xs",
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl",
  "2XL": "2xl"
};
Object.values(t);
const e = {
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6"
};
Object.values(e);
const c = l(({
  children: a,
  size: i = t.SM,
  tag: n = e.H1,
  ...o
}, r) => /* @__PURE__ */ g(x, { as: n, size: i, ...o, ref: r, "data-testid": "rango-heading", "data-rango-component": "rango-heading", "data-is-rango": !0, children: a }));
c.displayName = "RangoHeading";
export {
  t as H,
  c as R,
  e as a
};
